

import {Directive, Input, OnDestroy, OnInit, TemplateRef, ViewContainerRef} from '@angular/core';
import {forkJoin, of, zip} from 'rxjs';
import {UserInfoService} from 'fappi-common-model';
import {map, tap} from 'rxjs/operators';


export class HasGroupParams {
  orgId: string;
  groups: string[];
}

@Directive({
  selector: '[fappiHasGroup]'
})
export class HasGroupDirective implements OnInit, OnDestroy {

  constructor(private templateRef: TemplateRef<any>,
              private viewContainer: ViewContainerRef,
              private userInfoService: UserInfoService
  ) {
  }

  @Input() set fappiHasGroup(value: HasGroupParams) {
     this.applyPermission(value);
  }

  ngOnInit(): void {
    this.viewContainer.clear();
  }

  ngOnDestroy(): void {
  }

  private applyPermission(orgGroups: HasGroupParams): void {
    const isSuperadmin = this.userInfoService.hasRole(['ROLE_ADMIN']);
    const hasGroup = orgGroups.orgId ? this.userInfoService
      .hasGroup(orgGroups.orgId, orgGroups.groups, true) : of(false);
    forkJoin([isSuperadmin, hasGroup]).pipe(
      map(([isSuperadmin$, hasGroup$]) => isSuperadmin$ || hasGroup$),
    )
      .subscribe(hasRight => {
        if (hasRight) {
          this.viewContainer.clear();
          this.viewContainer.createEmbeddedView(this.templateRef);
        } else {
          this.viewContainer.clear();
        }
      });


  }

}
